import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Rutas from 'src/app/Models/Base/rutas';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { NewEnterpriseComponent } from '../list-enterprise/new-enterprise/new-enterprise.component';
import { PasswordChangedComponent } from '../password-changed/password-changed.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class WarningComponent {
  private token = '';
  constructor(
    public appStateService: AppStateService
    , private route: ActivatedRoute
    , private router: Router
  ) {
    const 
    navigation = this.router.getCurrentNavigation(),
    state = navigation?.extras.state;
    this.token = state?.state?.token || '';

    if(!this.token){
      this.appStateService.router.navigate([Rutas.LOGIN])
    }
  }

  public get routing(): {
    title: string;
    subtitle: string;
    action: Array<{ id: number; label: string }>;
  } | null {
    if (this.route.snapshot.data) {
      return this.route.snapshot.data?.['info'] || null;
    }
    return this.route.snapshot.data?.['info'] || null;
  }

  onSubmit(index: number) {
    switch (index) {
      case 1:
        this.appStateService.dialog.open(PasswordChangedComponent, {
          maxWidth: '95%',
          maxHeight: '95%',
          width: '491px',
          data: {
            accountID: '',
            token: this.token
          }
        });
        break;
      case 2:
        this.appStateService.router.navigateByUrl(Rutas.FORGOT_PASSWORD);
        break;

      case 3: {
        const dialogRef = this.appStateService.dialog.open(NewEnterpriseComponent, {
          maxWidth: '95%',
          maxHeight: '95%',
          width: '491px',
          data: this.token
        });

        dialogRef.beforeClosed()
        .subscribe(c =>{
          if(c?.action){
            this.appStateService.onLogin(this.appStateService.loginValues)
          }
        })
        break;
      }
       case 4:
        this.appStateService.onLogOut();
        break;
      default:
        this.appStateService.router.navigateByUrl(Rutas.LOGIN);
        break;
    }
  }
}
